import React from "react";
import { Grid } from "@material-ui/core";

import { EXECUTION_BRIEF_HOOK } from "../../../pages/execution-brief/types/execution-brief-template.interface";
import { REGEX_NO_CAPITAL_NO_WHITE_SPACE } from "../../../utils/constants";
import { TemplateName } from "../../../types/templates/template-name";
import { UserGroup } from "../../../constants/types";
import { useExecutionBriefTemplateOptions } from "../../../pages/execution-brief/types/execution-brief-template.hooks";

import { BorderedBlock } from "../../common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../forms/fields/checkbox-field/checkbox-field.component";
import { DateField } from "../../forms/fields/date-field/date-field.component";
import { RichTextField } from "../../forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";
import { SelectField } from "../../forms/fields/select-field/select-field.component";
import { TextField } from "../../forms/fields/text-field/text-field.component";
import { StatusSection } from "../../common-attributes/components/status-section/status-section.component";
import { UserSearchField } from "../../forms/fields/user-search-field/user-search-field.component";

import {
  COPY_DIRECTION,
  CREATIVE_DIRECTION,
  END_DATE,
  IS_REGIONAL,
  MERCH_OWNERS,
  NUMBER_OF_WORK_ORDERS_REQUESTED,
  PROJECT_OVERVIEW,
  REPORTING_MASTER_CAMPAIGN_NAME,
  START_DATE,
} from "../constants";

import { IExecutionBriefTemplate, pageType } from ".";
import { HiddenHeading } from "../../../pages/pages.styles";

export const ExecutionBriefPaidMediaTemplate = (props: IExecutionBriefTemplate) => {
  const { regionsOptions } = useExecutionBriefTemplateOptions([EXECUTION_BRIEF_HOOK.REGIONS]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={PROJECT_OVERVIEW.TITLE}
            name={PROJECT_OVERVIEW.ID}
            required
            subTitle={TemplateName.ExecutionBrief.PaidMedia}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={START_DATE.TITLE}
                name={START_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <DateField
                form={props.form}
                label={END_DATE.TITLE}
                name={END_DATE.ID}
                required
                userPermissions={props.userPermissions}
              />
            </Grid>
          </Grid>
        </BorderedBlock>
        <BorderedBlock>
          <TextField
            form={props.form}
            inputPattern={REGEX_NO_CAPITAL_NO_WHITE_SPACE}
            label={REPORTING_MASTER_CAMPAIGN_NAME.TITLE}
            name={REPORTING_MASTER_CAMPAIGN_NAME.ID}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={CREATIVE_DIRECTION.TITLE}
            name={CREATIVE_DIRECTION.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
        <BorderedBlock>
          <RichTextField
            form={props.form}
            label={COPY_DIRECTION.TITLE}
            name={COPY_DIRECTION.ID}
            userPermissions={props.userPermissions}
            withAdd
          />
        </BorderedBlock>
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusSection
          form={props.form}
          label="Status"
          name="status"
          pageType={pageType}
          userPermissions={props.userPermissions}
        />
        <BorderedBlock>
          <UserSearchField
            form={props.form}
            groupFilter={UserGroup.MERCH_OWNERS}
            label={MERCH_OWNERS.TITLE}
            name={MERCH_OWNERS.ID}
            resourceId={props.resourceId}
            resourceType={props.resourceType}
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
        <BorderedBlock>
          <CheckboxField
            form={props.form}
            label={IS_REGIONAL.TITLE}
            name={IS_REGIONAL.ID}
            userPermissions={props.userPermissions}
          >
            <SelectField
              form={props.form}
              label="Regions"
              multiple
              name="regions"
              options={regionsOptions}
              placeholder="Select Region"
              userPermissions={props.userPermissions}
            />
          </CheckboxField>
        </BorderedBlock>
        <BorderedBlock>
          <TextField
            form={props.form}
            label={NUMBER_OF_WORK_ORDERS_REQUESTED.TITLE}
            name={NUMBER_OF_WORK_ORDERS_REQUESTED.ID}
            numeric
            userPermissions={props.userPermissions}
          />
        </BorderedBlock>
      </Grid>
    </Grid>
  );
};
